<div class="flex flex-row items-center justify-between">
  <div class="offcanvas-header flex flex-col !justify-start !items-start">
    <h4 class="offcanvas-title">Add Account</h4>
    <p>Account for transactions in Komerce</p>
  </div>
  <div class="flex justify-end mr-4">
    <button type="button" class="btn" aria-label="Close" (click)="close()">
      <img
        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/close.svg"
        alt=""
        width="28px"
      />
    </button>
  </div>
</div>
<div class="divider"></div>
<form
  [formGroup]="formGroup"
  action=""
  class="offcanvas-body flex flex-col"
  style="align-content: space-between"
  (keydown.enter)="$event.preventDefault()"
>
  <div
    class="offcanvas-body flex flex-col"
    style="align-content: space-between"
    ref="offcanvas"
  >
    <div class="form" style="align-content: flex-start">
      <div class="bank">
        <label for="bank-name" class="form-label">Bank Name</label>
        <div class="relative">
          <input
            id="typeahead-template"
            [(ngModel)]="bank"
            type="search"
            class="form-control"
            style="padding-right: 35px"
            [ngbTypeahead]="search"
            #inputValue
            [inputFormatter]="formatter"
            [resultFormatter]="formatter"
            [selectOnExact]="true"
            placeholder="Search bank name"
            required
            formControlName="bank"
            (ngModelChange)="onSearchBank($event)"
            (keydown.enter)="$event.preventDefault()"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16"
            style="
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              pointer-events: none;
              color: #6c757d;
            "
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </div>
        <small class="text-red-500" *ngIf="isNotFound"
          >*The bank you are looking for does not exist</small
        >
        <small class="text-red-500 flex items-center gap-1" *ngIf="isEmptyBank">
          <img
            src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
            alt=""
            width="12px"
          />
          Please select the bank first</small
        >
      </div>
      <div class="mt-4">
        <label for="Rekening" class="form-label">Account</label>
        <input
          type="text"
          class="form-control"
          id="Rekening"
          placeholder="Enter Account Number"
          [(ngModel)]="rekening"
          (ngModelChange)="onAddRek($event)"
          required
          (keydown.enter)="$event.preventDefault()"
          formControlName="rekening"
          numberOnly
        />
        <small class="text-red-500 flex items-center gap-1" *ngIf="isEmptyRek">
          <img
            src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
            alt=""
            width="12px"
          />
          Account Cannot Be Empty</small
        >
      </div>
      <div class="mt-4">
        <label for="Nama" class="form-label">Name</label>
        <input
          type="text"
          class="form-control"
          id="Nama"
          placeholder="Enter your name"
          [(ngModel)]="owner"
          (ngModelChange)="onAddOwner($event)"
          required
          (keydown.enter)="$event.preventDefault()"
          formControlName="nama"
        />
        <small class="text-red-500 flex items-center gap-1" *ngIf="isEmptyOwn">
          <img
            src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
            alt=""
            width="12px"
          />
          Name Cannot Be Blank</small
        >
      </div>
    </div>
    <div
      class="flex flex-grow"
      style="align-content: flex-end; flex-wrap: wrap; margin-top: 2rem"
    >
      <button
        type="submit"
        class="btn btn-primary text-white"
        (click)="validateAdd()"
        [disabled]="formGroup.invalid"
      >
        Save
      </button>
    </div>
  </div>
</form>
